interface SidePanelState {
	isMobile: boolean;
	isOpen: boolean;
	mobileViewportScroll: boolean;
}

export interface SidePanelLayout {
	isMobileOverlay: boolean;
	showDismissBackdrop: boolean;
}

const resolveSidePanelLayout = ({ isMobile, isOpen, mobileViewportScroll }: SidePanelState): SidePanelLayout => ({
	isMobileOverlay: mobileViewportScroll && isMobile,
	showDismissBackdrop: mobileViewportScroll ? isOpen && isMobile : isOpen
});

export default resolveSidePanelLayout;
